import { css } from 'aphrodite';
import type { ComponentProps, ReactElement } from 'react';
import { useCallback } from 'react';
import {
	StickToBottom as StickToBottomOriginal,
	StickToBottomProps,
	useStickToBottomContext,
} from 'use-stick-to-bottom';
import { ChevronDown } from '../../../components/svgs/icons/ChevronDown';
import { bs } from '../../../styles/styles';
import { s } from './styles';

export type ConversationProps = AphroditeStyled<StickToBottomProps>;

// workaround for react < 19
const StickToBottom = StickToBottomOriginal as (
	...params: Parameters<typeof StickToBottomOriginal>
) => ReactElement | null;
const StickToBottomContent = StickToBottomOriginal.Content as (
	...params: Parameters<typeof StickToBottomOriginal.Content>
) => ReactElement | null;

export const ChatConversation = ({ styles = [], ...props }: ConversationProps) => {
	return (
		<StickToBottom
			className={css(s.chatConversation, ...styles)}
			initial='instant'
			resize='smooth'
			role='log'
			{...props}
		/>
	);
};

export type ConversationContentProps = AphroditeStyled<StickToBottomOriginal.ContentProps>;

export const ChatConversationContent = ({ styles = [], ...props }: ConversationContentProps) => (
	<StickToBottomContent className={css(bs.flex, bs.flexCol, bs.gap4, ...styles)} {...props} />
);

export type ConversationScrollButtonProps = AphroditeStyled<ComponentProps<'button'>>;

export const ChatConversationScrollButton = ({ styles = [], ...props }: ConversationScrollButtonProps) => {
	const { isAtBottom, scrollToBottom } = useStickToBottomContext();

	const handleScrollToBottom = useCallback(() => {
		scrollToBottom();
	}, [scrollToBottom]);

	return (
		!isAtBottom && (
			<button className={css(s.btnScrollToBottom, styles)} onClick={handleScrollToBottom} {...props}>
				<ChevronDown className={css(bs.w4, bs.h4)} />
			</button>
		)
	);
};
